import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setItem } from "../../../helpers/data_management";
import { updateSGJobReminderDialog } from "../../../redux/actions/dialog_action";

import Color from "../../../assets/colors";
import {
  BoxContainer,
  CheckboxStyled,
  CloseButton,
  CloseRoundedIconStyled,
  DialogActionsStyled,
  DialogContentStyled,
  DialogMessage,
  DialogStyled,
  DialogTitleStyled,
  FormControlLabelStyled,
  PrimaryButton,
  SGCountryFlag,
} from "./styles";

export const SHOW_SG_JOB_REMINDER_DIALOG_KEY = "showSGJobReminderDialog";

export default function SGJobPageReminderDialog() {
  const dialogOpen = useSelector(
    (state) => state.dialog?.showSGJobReminderDialog
  );
  const dispatch = useDispatch();
  const [checkboxValue, setCheckboxValue] = useState(false);

  function handleCheckboxChanged(e) {
    setCheckboxValue(e.target.checked);
  }

  function handleCloseDialog() {
    dispatch(updateSGJobReminderDialog(false));
  }

  function onButtonClick() {
    setItem(SHOW_SG_JOB_REMINDER_DIALOG_KEY, !checkboxValue);
    handleCloseDialog();
  }

  return (
    <DialogStyled open={dialogOpen}>
      <BoxContainer
        alignItems={"center"}
        justifyContent={"space-between"}
        padding={"1rem 1.5rem"}
        borderBottom={"1px solid " + Color.grey}
      >
        <DialogTitleStyled>
          You are viewing a job in Hiredly Singapore
          <SGCountryFlag />
        </DialogTitleStyled>

        <CloseButton onClick={handleCloseDialog}>
          <CloseRoundedIconStyled />
        </CloseButton>
      </BoxContainer>
      <DialogContentStyled>
        <DialogMessage>
          Jobs in Hiredly Singapore are posted by Singaporean employers and may
          require working in Singapore unless stated otherwise (eg. remote jobs,
          overseas employers).
        </DialogMessage>
        <FormControlLabelStyled
          control={
            <CheckboxStyled
              onChange={handleCheckboxChanged}
              checked={checkboxValue}
            />
          }
          label="Do not show this message again"
        />
      </DialogContentStyled>
      <DialogActionsStyled>
        <PrimaryButton onClick={onButtonClick}>Okay</PrimaryButton>
      </DialogActionsStyled>
    </DialogStyled>
  );
}
